import { Replay } from '@mui/icons-material';
import './Version.scss';

const Version = () => {
  const hardReload = () => {
    globalThis.location.reload(true);
  };

  return (
    <div className='version' onClick={hardReload}>
      v3.1.11
      <Replay className='version__reload-icon' />
    </div>
  )
};

export default Version;
